import { InitialReservationInquiryAmount } from '.';

export const types = {
  RESERVATION_INQUIRY_AMOUNT_SIDEBAR: 'RESERVATION_INQUIRY_AMOUNT_SIDEBAR' as const,
};

export const saveReservationInquiryAmountSideBar = (payload: InitialReservationInquiryAmount) => ({
  type: types.RESERVATION_INQUIRY_AMOUNT_SIDEBAR,
  payload,
});

export type Actions = (
  | ReturnType<typeof saveReservationInquiryAmountSideBar>
);
